var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellRoundedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.125,
    cy: 24.75,
    r: 24,
    fill: "#00A3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8511 26.4121C29.8511 28.0699 30.5875 29.5955 31.8622 30.6786H26.9396H24.0005H21.0602H16.1385C17.4131 29.5951 18.1499 28.0703 18.1499 26.4121V23.0685C18.1499 21.8036 18.5545 20.1994 19.4948 18.9305C20.4136 17.6908 21.8545 16.75 24.0324 16.75C26.2091 16.75 27.6323 17.6896 28.5348 18.9261C29.4596 20.1931 29.8511 21.798 29.8511 23.0685V26.4121Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5716 31.4287C26.5716 32.8489 25.4203 34.0001 24.0001 34.0001C22.58 34.0001 21.4287 32.8489 21.4287 31.4287",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRoundedBlue);
export default __webpack_public_path__ + "static/media/bell-rounded-blue.c53bfc3e4cdd27b076e7febf425d8b36.svg";
export { ForwardRef as ReactComponent };